document.addEventListener('alpine:init', () => {

    const DEFAULT_LINK_DATA =
    {
        link_name: '',
        source: '',
        custom_source: false,
        has_link_name_error: false,
        has_source_error: false,
        link_name_error_text: '',
        source_error_text: '',
    };

    const SUBMIT_BUTTON_TEXT = 'Next: Add listening apps';
    const MAX_LINKS = 10;
    const MAX_LINK_NAME_LENGTH = 150;
    const MIN_LINK_NAME_LENGTH = 3;
    const MAX_SOURCE_LENGTH = 30;

    Alpine.data('new_tracking_link_x_data', () => ({
        // TomSelect instance
        prefix_episode_select: null,
        // URL for searching episodes
        episode_search_url: '',
        submit_button_text: SUBMIT_BUTTON_TEXT,
        submit_button_disabled: false,
        // Link types in show, episode
        link_type: '',
        link_type_error: false,
        no_episode_selected_error: false,
        // Array of additional episode links
        additional_links: [],
        // Array of sources, loaded from the server and also used to check for duplicates
        source_list: [],
        check_name_url: '',
        max_links: MAX_LINKS,
        // Unique index for each link set, starts from 0 and increments
        next_id: 0,

        init() {

            const url_data = this.$refs.url_data;
            this.episode_search_url = url_data.dataset.episodeSearchUrl;
            this.source_list = JSON.parse(url_data.dataset.sourceList);
            this.check_name_url = url_data.dataset.checkNameUrl;
            this.source_list.push('Other');
            
            // Initialize TomSelect with remote loading
            this.$nextTick(() => {
                this.initTomSelect();
            });

            // Create default link data with the first source from the list
            const defaultLinkData = {
                ...JSON.parse(JSON.stringify(DEFAULT_LINK_DATA)),
                source: this.source_list[0] || '',
                id: this.next_id++,
            };

            this.additional_links.push(defaultLinkData);

            // Logic that determines what happens when a user switches from episode to show link and vice versa
            this.$watch('link_type', (new_value, old_value) => {
                // When the link_type changes from episode to show, ask the user to confirm
                // If they confirm, clear the episode additional links

                /*if (this.link_type === 'episode' && old_value === 'show') {
                    if (this.additional_links.length > 0 && this.additional_links[0].link_name !== '') {
                        let confirmation = confirm("Are you sure you want to change the link type? This will clear all existing links.");
                        if (confirmation) {
                            this.additional_links = [];
                            this.additional_links.push({
                                ...JSON.parse(JSON.stringify(DEFAULT_LINK_DATA)),
                                id: this.next_id++,
                            });
                            this.prefix_episode_select.setValue('');
                        } else {
                            this.link_type = old_value;
                        }
                    }
                }*/


                // If the link_type changes to episode, clear the episode_id if present
                if (this.link_type === 'show') {
                    this.prefix_episode_select.setValue('');
                }
            });
        },
        
        initTomSelect() {

            const selectElement = document.querySelector('#ql_select_episode');
            if (!selectElement) {

                return;
            }
            
            this.prefix_episode_select = new TomSelect('#ql_select_episode', {
                maxItems: 1,
                valueField: 'id',
                labelField: 'title',
                searchField: 'title',
                placeholder: 'Type at least 2 characters to search...',
                create: false,
                loadThrottle: 300, // Debounce for 300ms
                loading: true, // Show loading indicator
                load: (query, callback) => {
                    if (!query.length || query.length < 2) {

                        return callback();
                    }
                    

                    
                    fetch(`${this.episode_search_url}?q=${encodeURIComponent(query)}`)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(`HTTP error! status: ${response.status}`);
                            }
                            return response.json();
                        })
                        .then(json => {

                            callback(json.episodes || json);
                        })
                        .catch(error => {

                            callback();
                        });
                },
                render: {
                    loading: function(data, escape) {
                        return '<div class="py-2 px-3 text-sm text-gray-500">Searching episodes...</div>';
                    },
                    no_results: function(data, escape) {
                        return '<div class="py-2 px-3 text-sm text-gray-500">No episodes found.</div>';
                    }
                }
            });
            

        },

        add_link_set() {
            if (this.additional_links.length < this.max_links) {
                // Deep copy the default link data to avoid reference issues
                const newLinkData = {
                    ...JSON.parse(JSON.stringify(DEFAULT_LINK_DATA)),
                    source: this.source_list[0] || '',
                    id: this.next_id++,
                };
                this.additional_links.push(newLinkData);
            }
        },

        handle_custom_source(index) {
            if (this.additional_links[index].source === 'Other') {
                this.additional_links[index].source = '';
                this.additional_links[index].custom_source = true;
                this.additional_links[index].has_source_error = false;
                this.additional_links[index].source_error_text = '';
            }
        },

        remove_link_set(index) {
            if (this.additional_links.length > 1) {
                this.additional_links.splice(index, 1);
            }
        },

        handle_enter_key(event) {
            const tag = event.target.tagName.toLowerCase();
            const type = event.target.getAttribute('type');

            // Allow default behavior for textareas and buttons
            if (tag === 'textarea' || type === 'submit' || type === 'button') return;

            // Pressing Enter in a text input or select submits the form
            if (tag === 'input' || tag === 'select') {
                event.preventDefault();
                this.validate_links(event);
            }
        },
        async validate_links(event) {
            const sources = new Set();
            const link_names = new Set();
            let has_error = false;
            let that = this;

            this.submit_button_disabled = true;
            this.submit_button_text = 'Submitting...';
            // Reset all error states
            this.link_type_error = false;
            this.no_episode_selected_error = false;
            this.additional_links.forEach((link) => {
                link.has_link_name_error = false;
                link.link_name_error_text = '';
                link.has_source_error = false;
                link.source_error_text = '';
            });

            if (this.link_type === '' || this.link_type === null) {
                has_error = true;
                that.link_type_error = true;
            }

            // First pass: synchronous validations
            this.additional_links.forEach((link, i) => {
                const name = link.link_name.trim();
                const source = link.source.trim();
                const custom_source = link.custom_source;

                if (!name) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = 'Link name cannot be empty.';
                }

                if (link_names.has(name)) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = 'Duplicate link name found.';
                }

                if (name.length < MIN_LINK_NAME_LENGTH) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = `Link name must be at least ${MIN_LINK_NAME_LENGTH} characters.`;
                }

                //Name should not contain special characters
                if (/[^a-zA-Z0-9 $\-&''\u2018\u2019()\.\,\:\;\!\?\u2013\u2014]/.test(name)) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = 'Link name contains unsupported characters.';
                }

                // Source should not contain special characters
                if (/[^a-zA-Z0-9 ]/.test(source)) {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = 'Source cannot contain special characters.';
                }

                if (custom_source && source.toLowerCase() === 'other') {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = 'Source cannot be "Other". Please select a valid source.';
                }

                if (name.length > MAX_LINK_NAME_LENGTH) {
                    has_error = true;
                    link.has_link_name_error = true;
                    link.link_name_error_text = `Link name cannot exceed ${MAX_LINK_NAME_LENGTH} characters.`;
                }

                if (source.length > MAX_SOURCE_LENGTH) {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = `Source cannot exceed ${MAX_SOURCE_LENGTH} characters.`;
                }

                if (!source) {
                    has_error = true;
                    link.has_source_error = true;
                    link.source_error_text = 'Source cannot be empty.';
                }

                sources.add(source);
                link_names.add(name);
            });

            if (this.additional_links.length === 0) {
                has_error = true;
                this.additional_links[0].has_link_name_error = true;
                this.additional_links[0].link_name_error_text = 'At least one link is required.';
            }

            if (this.link_type === 'episode') {
                if (this.prefix_episode_select.getValue() === '' || this.prefix_episode_select.getValue() === null) {
                    has_error = true;
                    this.no_episode_selected_error = true;
                }
            }

            if (has_error) {
                this.submit_button_disabled = false;
                this.submit_button_text = SUBMIT_BUTTON_TEXT;
                return;
            }

            // Second pass: async backend validation for name uniqueness
            try {
                const nameCheckPromises = this.additional_links.map(async (link) => {
                    const name = link.link_name.trim();
                    if (!name) return; // Skip empty names (already handled above)
                    
                    const response = await fetch(`${this.check_name_url}?name=${encodeURIComponent(name)}`, {
                        headers: {
                            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    });
                    
                    const result = await response.json();
                    
                    if (!result.available) {
                        has_error = true;
                        link.has_link_name_error = true;
                        link.link_name_error_text = result.message || 'A tracking link with this name already exists';
                    }
                });
                
                await Promise.all(nameCheckPromises);
                
                if (has_error) {
                    this.submit_button_disabled = false;
                    this.submit_button_text = SUBMIT_BUTTON_TEXT;
                    return;
                }
            } catch (error) {

                // Continue with submission even if backend check fails
            }

            this.handle_form_submit(event);

        },
        handle_form_submit(event) {
            // Submit the form
            const form = this.$refs.tracking_link_form;
            const formData = new FormData(form);

            if (this.link_type === 'episode') {
                const episodeId = this.prefix_episode_select.getValue();
                formData.append('episode_id', episodeId);
            } else {
                formData.delete('episode_id');
            }

            formData.append('link_type', this.link_type);

            fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        // next_url to go to to the next screen
                        sessionStorage.setItem('flash_message', JSON.stringify(['notice', 'Your tracking link(s) have been created!']))
                        window.location.href = data.next_url;
                    } else {
                        alert('Error: ' + data.error);
                        this.submit_button_disabled = false;
                        this.submit_button_text = SUBMIT_BUTTON_TEXT;
                    }
                })
                .catch(error => {});
        }
    }));
})

